import { HistoryService } from './history/history.service';
import { NgModule } from '@angular/core';
import { ExportConfigurationRoutingModule } from './export-configuration-routing.module';
import { ExportConfigurationRoutesService } from './export-configuration-routes.service';
import { ExportConfigurationService } from './export-configuration.service';
import { ConfigurationFormCoordinatorService } from './shared/configuration-forms/configuration-form-coordinator.service';
import { EmailTemplatesOverviewService } from './shared/email-templates-overview/email-templates-overview.service';
import { FieldAssignmentTemplatesOverviewService } from './shared/field-assignment-templates-overview/field-assignment-templates-overview.service';
import { ActivationEmailTemplatesOverviewService } from './shared/activation-email-templates-overview/activation-email-templates-overview.service';
import { ActivationEmailService } from './activation-email.service';
import { FieldValueReplacementService } from './field-value-replacements/field-value-replacement.service';
import { OutputEmailAccountsService } from './activation-email-templates/output-email-accounts.service';

@NgModule({
    imports: [
        ExportConfigurationRoutingModule,
    ],
    providers: [
        ExportConfigurationRoutesService,
        ExportConfigurationService,
        ConfigurationFormCoordinatorService,
        EmailTemplatesOverviewService,
        ActivationEmailTemplatesOverviewService,
        FieldAssignmentTemplatesOverviewService,
        HistoryService,
        ActivationEmailService,
        FieldValueReplacementService,
        OutputEmailAccountsService
    ],
})
export class ExportConfigurationModule {
}
